module.exports = __webpack_public_path__ + "media/yserr.93ebef03.mp3";